import { i18n } from '@lingui/core';

export const getTranslations = () => ({
    FULL_ACCESS: i18n._('accessToggle.fullAccess'),
    RESTRICT_STUDENTS: i18n._('accessToggle.restrictStudents'),
    POPOVER_TEXT: i18n._('accessToggle.popoverText')
});

